import { render, staticRenderFns } from "./StaffAttendanceDetail.vue?vue&type=template&id=afe5a782&scoped=true"
import script from "./StaffAttendanceDetail.vue?vue&type=script&lang=js"
export * from "./StaffAttendanceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe5a782",
  null
  
)

export default component.exports